import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const DonutChart = ({ chartData }) => {
	const plugins = [
		{
			beforeDraw: function (chart) {
				let width = chart.width;
				let height = chart.height;
				let ctx = chart.ctx;
				ctx.restore();
				let fontSize = (height / 160).toFixed(2);
				ctx.font = fontSize + 'rem sans-serif';
				ctx.textBaseline = 'top';
				let text = chartData.datasets[0].data[0];
				let textX = Math.round((width - ctx.measureText(text).width) / 2);
				let textY = height / 2;
				ctx.fillText(text, textX, textY);
				ctx.save();
			},
		},
	];

	const options = {
		aspectRatio: 2,
		responsive: true,
		plugins: {
			legend: {
				display: false,
			},
			tooltip: {
				enabled: false,
			},
		},
		cutout: '80%',
		circumference: 180,
		rotation: -90,
	};

	return <Doughnut data={chartData} options={options} plugins={plugins} />;
};

export default DonutChart;
